module.exports = __webpack_public_path__ + "img/brand-cases1.dc4daf35.png";